import axios from './axios'
import config from '../config'
import { mapToken } from '../staff-helper'
import { toQueryWithQuestionMark } from '../tools'

const mapSsoUrl = (path) => `${config.STAFF_SSO_URL}${path}`;
const mapStaffUrl = (path) => `${config.STAFF_API_URL}${path}`;
export const sso = {
    logout: token => axios.delete(mapSsoUrl('/v1/sso'), mapToken(token)),
    checkStatus: token => axios.head(mapSsoUrl('/v1/sso'), mapToken(token)),
    login: idToken => axios.post(mapSsoUrl('/v1/sso/login-with-google'), { idToken: idToken })
};

let staffUrl = mapStaffUrl('/v1/Staff')
let nomineeUrl = mapStaffUrl('/v1/Staff/Nominees')

export const staff = {
    getBookings: (request) =>
        axios.get(mapStaffUrl(`/v1/Staff/Bookings${toQueryWithQuestionMark(request)}`)),
    getStaff: () =>
        axios.get(staffUrl),
    updateStaff: (token, updRequest) =>
        axios.put(staffUrl, updRequest, mapToken(token)),
    getNominees: token =>
        axios.get(nomineeUrl, mapToken(token)),
    addNominee: (token, addRequest) =>
        axios.post(nomineeUrl, addRequest, mapToken(token)),
    updateNominee: (token, updRequest) =>
        axios.put(nomineeUrl, updRequest, mapToken(token)),
    deleteNominee: (token, uuid) =>
        axios.delete(`${nomineeUrl}?uuid=${uuid}`, mapToken(token)),
    getSummary: (year) => axios.get(`${nomineeUrl}/Summary/${year}`)
    // !! no cors
    // submitNominees: (token, submitRequest) =>
    //     axios.post(staffUrl('v1/Staff/Nominees/submit'), submitRequest, mapToken(token))
};

export const common = {
    getTranslationData: () => axios.get(config.TRANSLATION_URL)
}

